export const ACCOUNT_PATH = '/account';
export const ACCOUNT_INTERVIEW_PATH = '/account/interviews';
export const ACCOUNT_CV_PATH = '/account/cv-analysis';
